import TireCard from 'pages/CatalogPage/DH/Tires/TireCard/TireCard';

export default TireCard;
